/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchClassifyResponseClassifiersItem4 = typeof SearchClassifyResponseClassifiersItem4[keyof typeof SearchClassifyResponseClassifiersItem4];


export const SearchClassifyResponseClassifiersItem4 = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
